<template>
    <div>
    <b-container fluid>
      <b-card>
        <b-row>
             <b-col cols='11'>
                <h3 class='text-center text-uppercase'>Proceso alistamiento</h3>
                <h5 class='text-center text-uppercase'>{{pending}} Pedidos pendientes</h5>
            </b-col>
            <!--<b-col>
                <b-button size='sm' variant='primary' @click="sizePluss" ><i class='fa fa-plus-circle fa-lg'></i></b-button>
                <b-button size='sm' variant='primary' @click='sizeMinus'><i class='fa fa-minus-circle fa-lg'></i></b-button>
            </b-col>-->
        </b-row>
        <br>
        <b-row>
            <b-col style="font-size:36px">
            <b-table striped hover :items='items' :fields='fields' class="text-center">
                <template slot='dispatch' slot-scope='row'>
                <b-button style="font-size:25px" :size='sizeButtons' variant='success' @click="toDispatch(row.item)">
                    <i class='fa fa-check fa-lg'></i>
                </b-button>
                </template>
            </b-table>
            </b-col>
        </b-row>
      </b-card>
    </b-container>
    </div>
</template>
<script>
export default {
  name: 'external_enlisment',
  data () {
    return {
      fields: [
        {
          key: 'turn',
          label: 'Turno',
          sortable: true
        },
        {
          key: 'products',
          label: 'Detalle del pedido',
          sortable: true
        },
        {
          key: 'comment',
          label: 'Observaciones',
          sortable: true
        },
        {
          key: 'count',
          label: 'No de productos',
          sortable: true
        },
        {
          key: 'dispatch',
          label: ''
        }
      ],
      items: [],
      sizeButtons: 'lg',
      counter: 2,
      pending: 0,
      turns: [],
      maxturn: 60,
      minturn: 50
    }
  },
  watch: {
    items: function (newval) {
      this.pending = this.items.length
    }
  },
  mounted () {
    this.getData()
    window.setInterval(this.getData, 10000);
  },
  methods: {
    sizePluss () {
      this.counter = this.counter === 3 ? 3 : this.counter + 1
      this.sizeButtons = this.selectSize(this.counter)
    },
    generateTurn () {
      for (let i = 1; i < this.maxturn; i++) {
        if (this.turns[i] === undefined) {
          this.turns[i] = i
          return i
        }
      }
    },
    sizeMinus () {
      this.counter = this.counter === 1 ? 1 : this.counter - 1
      this.sizeButtons = this.selectSize(this.counter)
    },
    selectSize (valu) {
      switch (valu) {
        case 1:
          return 'sm'
        case 2:
          return 'md'
        case 3:
          return 'lg'
      }
    },
    getData () {
      this.$store.dispatch('cafeteriaRequestsAllExternal').then((response) => {
        this.items = this.$store.getters.cafeteriaRequestsExt
        this.pending = this.items.length
      }).catch((error) => {
        console.error(error)
      })
    },
    toDispatch (item) {
      this.$store.dispatch('cafeteriaRequestsDispatch', item).then((response) => {
        this.getData()
      }).catch((error) => {
        console.log('Eror ', error)
      })
      let turno = item.turno
      this.turns.splice(turno, 1)
      this.items.forEach((element, k) => {
        if (element.id === item.id) {
          this.items.splice(k, 1)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/external/enlistment/index.vue